export const productTypes = {
  'MOORING': 'mooring',
};

export const PRODUCTS_MAPPING = {
	availabilityType: 'price.availabilityType'
};

// TODO: This is temporary, remove once Moorings has BDP setup.
export const moorings = new Set([
  'moorings',
  'ligplaatsen',
  'places-de-port',
  'liegeplatze',
  'posti-barca'
]);
